import { AssociationType } from '@libs/associations';
import type { ProductAttribute, ProductAttributeValueAmountUnit } from '@libs/attribute.helper';
import { getAttributeValue } from '@libs/attribute.helper';
import type { AssociationProductFragmentEnhanced, ProductFragmentEnhanced } from '@models/enhanced-fragments';

/**
 * returns the cfCase products if set for given product && the max length is defined
 */
export const getCfCaseProducts = (
  product: ProductFragmentEnhanced,
  associationProducts: Record<string, AssociationProductFragmentEnhanced>
) => {
  const cfCaseMaxLength = getAttributeValue<ProductAttributeValueAmountUnit>(
    product?.attributes?.CFCase_length_max_metric as ProductAttribute<ProductAttributeValueAmountUnit>
  );
  const cfCases = product.product_to_product_associations
    ?.filter(association => association.type === AssociationType.CF_CASE)
    ?.map(value => value.productByProductIdTarget?.id)
    ?.filter(id => id)
    ?.map(value => associationProducts[value])
    ?.filter(Boolean);

  if (cfCases?.length === 0 || !cfCaseMaxLength?.amount) {
    return null;
  }
  return cfCases;
};
